module.exports = __webpack_public_path__ + "static/media/authorAvatar3.63c2d921.jpeg";